import { Icon } from '@chakra-ui/icon';
const DotsVertical = props => <Icon {...props} data-sentry-element="Icon" data-sentry-component="DotsVertical" data-sentry-source-file="DotsVertical.tsx">
    <path d="M12 6.5A3.25 3.25 0 1012 0a3.25 3.25 0 000 6.5zM12 15.25a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5zM12 24a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="DotsVertical.tsx" />
  </Icon>;
DotsVertical.displayName = 'DotsVerticalIcon';
export default DotsVertical;